import { render, staticRenderFns } from "./bottom-section.vue?vue&type=template&id=405cbfb0&scoped=true&"
import script from "./bottom-section.vue?vue&type=script&lang=ts&"
export * from "./bottom-section.vue?vue&type=script&lang=ts&"
import style0 from "./bottom-section.vue?vue&type=style&index=0&id=405cbfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405cbfb0",
  null
  
)

export default component.exports